import jMoment from 'moment-jalaali';
import { FILTER_TYPES } from 'components/FilterPod';

const InitFilteringReportSummary = [
  {
    title: 'تاریخ تراکنش',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'transaction',
    id: {
      start: 'transactionStartDate',
      end: 'transactionEndDate',
    },
    value: {
      start: jMoment(new Date().setHours(0, 0, 0, 0)).subtract(7, 'days'),
      end: jMoment(new Date().setHours(23, 59, 0, 0)),
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {},
      end: {},
    },
    disableDelete: true,
  },

  {
    title: 'تاریخ تفویض وجه',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'delegation',
    id: {
      start: 'delegationStartDate',
      end: 'delegationEndDate',
    },
    value: {
      start: jMoment(new Date().setHours(0, 0, 0, 0)).subtract(7, 'days'),
      end: jMoment(new Date().setHours(23, 59, 0, 0)),
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {},
      end: {},
    },
    disableDelete: true,
  },
];

export default InitFilteringReportSummary;

